import React from 'react';
import { Rnd } from 'react-rnd';
import { Badge, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const DraggableResizableField = ({
  drawId,
  x,
  y,
  width,
  height,
  scale,
  onDragEnd,
  onDelete,
  email,
  page0YPrevPages,
  openEditFieldSettings,
  fieldType,
  fieldColor,
  signerColor,
  signerLabel,
}) => {
  const handleDragStop = (e, d) => {
    const scaledX = (d.x / scale).toFixed();
    const scaledY = (d.y / scale).toFixed();
    const page0Y = page0YPrevPages + scaledY;
    onDragEnd(drawId, scaledX, scaledY, width, height, page0Y);
  };

  const handleResizeStop = (e, direction, ref, delta, position) => {
    const newWidth = (ref.style.width.replace('px', '') / scale).toFixed();
    const newHeight = (ref.style.height.replace('px', '') / scale).toFixed();
    const scaledX = (position.x / scale).toFixed();
    const scaledY = (position.y / scale).toFixed();
    const page0Y = page0YPrevPages + scaledY;
    onDragEnd(drawId, scaledX, scaledY, newWidth, newHeight, page0Y);
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
    openEditFieldSettings({
      drawId: drawId,
    });
  };

  return (
    <Rnd
      position={{ x: x * scale, y: y * scale }}
      size={{ width: width * scale, height: height * scale }}
      scale={1}
      onDragStop={handleDragStop}
      onResizeStop={handleResizeStop}
      bounds="parent"
      minWidth={12 * scale}
      minHeight={12 * scale}
    >
      <div
        id={drawId + '_' + email}
        className="draggable-resizable-field-container"
        style={{ borderColor: signerColor}} 
        title={email + ' ' + fieldType}
        onContextMenu={handleContextMenu}
      >
        <Badge.Ribbon
          text={fieldType}
          color={fieldColor}
          className="field-type-badge"
        />
        <Button danger type="primary" size="small" icon={<CloseOutlined />} onClick={() => onDelete(drawId)} className="field-close-button" />

        <div className="field-div">{signerLabel}</div>
      </div>
    </Rnd>
  );
};

export default DraggableResizableField;
